import FastMarquee from "react-fast-marquee";
import { useLanguage } from "@/i18n/LanguageContext";

export const Marquee = () => {
    const { t } = useLanguage();
    return (
        <section
            data-testid="editorial-marquee"
            className="border-y border-white/10 bg-[#070707] py-8 md:py-10"
        >
            <FastMarquee speed={28} gradient={false}>
                {t.marquee.map((w, i) => (
                    <span key={w} className="mx-8 flex items-center gap-16 md:mx-12">
                        <span
                            className={`whitespace-nowrap font-display text-4xl tracking-tight md:text-6xl ${
                                i % 2 ? "text-stroke-gold italic" : "text-bone"
                            }`}
                        >
                            {w}
                        </span>
                        <span className="h-2 w-2 rotate-45 bg-gold" />
                    </span>
                ))}
            </FastMarquee>
        </section>
    );
};
